module.exports = "/templates/changepassword.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/changepassword.html
// module id = 439
// module chunks = 0